// Agent color and avatar assignment utility
// 8 distinct hues for consistent agent identification

const COLORS = [
  '#FF6B6B', // coral red
  '#4ECDC4', // teal
  '#45B7D1', // sky blue
  '#96CEB4', // sage green
  '#FFEAA7', // warm yellow
  '#DDA0DD', // plum
  '#FF8C42', // orange
  '#98D8C8', // mint
];

function hashString(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
  }
  return Math.abs(hash);
}

export function getAgentColor(agentId: string): string {
  return COLORS[hashString(agentId) % COLORS.length];
}

export function getAgentInitials(agentId: string): string {
  // e.g. "research_agent" → "RES" or "RAG" (max 3)
  const words = agentId.replace(/[_-]/g, ' ').split(' ').filter(Boolean);
  if (words.length === 1) {
    const w = words[0];
    return w.substring(0, 3).toUpperCase();
  }
  return words
    .slice(0, 3)
    .map((w) => w[0].toUpperCase())
    .join('');
}

export { COLORS };
